import { createController, prepActions } from "~/hocs/crud";
import { service } from "./service";

// Growth stage log actions
export const actions = prepActions(service);

// Growth stage log sagas
export const growthStageLogSagas = createController(service, actions);
